import { useState, useEffect, useRef } from "react";
import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { MusicSection } from "@/components/MusicSection";
import { VisualsSection } from "@/components/VisualsSection";
import { ReleasesSection } from "@/components/ReleasesSection";
import { RemixesSection } from "@/components/RemixesSection";
import { EPKSection } from "@/components/EPKSection";
import { EventsSection } from "@/components/EventsSection";
import { MailingListSection } from "@/components/MailingListSection";
import { BookingDialog } from "@/components/BookingDialog";
import { FooterSection } from "@/components/FooterSection";

export default function HomePage() {
  const [bookingOpen, setBookingOpen] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    const sections = document.querySelectorAll(".reveal-section");
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div data-testid="home-page" className="relative">
      <Navigation onBookNow={() => setBookingOpen(true)} />
      <HeroSection onBookNow={() => setBookingOpen(true)} />

      <div id="about" className="reveal-section">
        <AboutSection />
      </div>

      <div id="music" className="reveal-section">
        <MusicSection />
      </div>

      <div id="visuals" className="reveal-section">
        <VisualsSection />
      </div>

      <div id="releases" className="reveal-section">
        <ReleasesSection />
      </div>

      <div id="remixes" className="reveal-section">
        <RemixesSection />
      </div>

      <div id="epk" className="reveal-section">
        <EPKSection />
      </div>

      <div id="events" className="reveal-section">
        <EventsSection />
      </div>

      <div className="reveal-section">
        <MailingListSection />
      </div>

      <FooterSection />

      <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} />
    </div>
  );
}
